<template>
    <div class="IdSearchResult">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>비밀번호 찾기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_back.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <!-- 회원정보가 없을 경우 -->
            <template v-if="result == '' || result.length==0">
                <div class="padding-50">
                    <img src="@/assets/images/find_search_no.png" width="100%" />
                </div>
                <p class="info-msg mrg-btm-40">
                    입력하신 정보와 일치하는 비밀번호가 없습니다.<br/>
                    정보 확인 후, 다시 시도해 주세요.
                </p>
                <button class="btn-big btn-bule"
                        @click.prevent="slidePanelClose">
                    다른 방법으로 비밀번호 찾기
                </button>
            </template>
            <!-- 회원정보가 있을 경우 -->
            <template v-else>
                <h2 class="slidePanel-title">
                    회원정보에 등록된 휴대폰 또는 이메일로 발송됩니다.<br />
                    받으실 방법을 선택해주세요.
                </h2>
                <ul class="li-bottom-line">
                    <li>
                        <span>
                            <label class="rad">
                                <input type="radio"
                                       value="phone"
                                       v-model="resultType" />
                                <i></i>
                                휴대폰 번호
                            </label>
                        </span>
                        <div v-show="resultType == 'phone'">
                            <div class="form-box mrg-top-10 mrg-left-30">
                                {{strPhoneNumber | phoneHidden}}
                            </div>
                        </div>
                    </li>
                    <li>
                        <span>
                            <label class="rad">
                                <input type="radio"
                                       value="email"
                                       v-model="resultType" />
                                <i></i>
                                이메일
                            </label>
                        </span>
                        <div v-show="resultType == 'email'">
                            <div class="form-box mrg-top-10 mrg-left-30">
                                {{strEmail | emailHidden}}
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="mrg-top-50">
                    <button class="btn-big btn-bule"
                            @click.prevent="formSend">
                        전송하기
                    </button>
                </div>
            </template>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'IdSearchResult',
    props: ['pResult'],
    data() {
        return {
            resultType:'',      // 임시비밀번호 받는 방법(휴대폰, 이메일)
            strUserId:'',       // 아이디
            strPhoneNumber:'',  // 휴대폰번호
            strEmail:'',        // 이메일
            result:[],          // 검색결과

            errorField:'',      // error 항목
            errorMsg:'',        // error 메시지
        }
    },
    filters: {
        // 일부 전화번호 히든처리
        phoneHidden:function (str){
            let phone = str.split('-')
            return phone[0]+"-****-"+phone[2];
        },
        // 일부 이메일 히든처리
        emailHidden:function(str){
            let email = str.split('@')
            return email[0].substring(0,email[0].length-3)+'***@'+email[1];
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.result = this.pResult;
        if (this.result && this.result.length > 0){
            this.strUserId = this.pResult[0].strUserId;
            this.strPhoneNumber = this.pResult[0].strEmpPhone;
            this.strEmail = this.pResult[0].strEmail;
        }
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 임시비밀번호 발송
        formSend(){
            if (!this.resultType){
                this.toastMsg('임시 비밀번호를 받으실 방법을 선택해 주세요.',1500);
                return false;
            }

            let formData = new FormData();
            if (this.resultType == 'phone'){
                formData.append('strUserId', this.strUserId);
                formData.append('strPhoneNumber', this.strPhoneNumber);
            }else{
                formData.append('strUserId', this.strUserId);
                formData.append('strEmail', this.strEmail);
            }
            this.ajaxPost('/api/v1/find/password/send/'+this.resultType, formData,this.formSendResult);
        },
        // 임시비밀번호 발송 결과
        formSendResult(response){
            let result = response.result;
            if (result.code == 0){
                let props = {
                    pResultType : this.resultType,
                };
                const panel =this.$showPanel({
                    component: () => import('./PwSearchResultSend.vue'),
                    props: props,
                    openOn: 'right',
                    width:screen.width,
                });
                panel.promise.then(result => {
                    window.callbackBackKey = this.callbackBackKey;
                    if (result.result === "close"){
                        this.slidePanelClose(result);
                    }
                });
            }else{
                this.resultErrorMsg = result.resultNoti.message;
            }
        },
    }
}
</script>

<style scoped>
</style>
